import BaseApi from './_baApi';
import httpClient from '@/apis/base/httpclient';

class BaWithdawAPI extends BaseApi {
  constructor() {
    super();
  }
  controllerName = 'BAWithdraws';

  // Xóa nhiều
  // lttuan1 - 9.8.22
  async customDelete(payload) {
    let request = {
      url: this.getAPIUrl() + '/CustomDelete',
      data: payload,
    };

    return await httpClient.deleteAsync(request);
  }

  getDataVoucher(payload) {
    let request = {
      url: this.getAPIUrl() + '/DataVoucher',
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Lấy thông tin của chi tiền gửi trả lương theo relation_ref_id và ref_type
   * @param {*} payload
   * @returns
   * tvhien 03.11.2022
   */
  getDataByRelationID(payload) {
    let request = {
      url: this.getAPIUrl() + '/getDataByRelationID',
      data: payload,
    };

    return httpClient.getAsync(request);
  }

  /**
   * lấy dữ liệu cho cho bảng nhập nội dung thanh toán khi vào form tham số lần đầu , mẫu 05TT
   * @param {*} refId
   * @returns
   */
   getDataForEnterPaymentContent(refId) {
    let request = { url: [this.getAPIUrl(), `GetDataForEnterPaymentContent?refId=${refId}`].join('/') };
    return httpClient.getAsync(request);
  }
}

export default new BaWithdawAPI();
